/* eslint-disable no-loop-func */
import React, { PureComponent } from "react";
import styled from 'styled-components';
import { Loader } from 'react-loaders';
import { getRequest } from "../../api/ApiService";
import PeerEvaluation from "../../components/peer-evaluation";
import { isSurveyFinished } from '../../api/Surveys';

const Wrapper = styled.div`
  background: #f5f6f7;
  padding: 40px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;

  .loader {
    display: inline-block;
    margin-top: 20px;
  }

  .loader .loader-inner div {
    border-color: #36507e;
  }
`;

const CenteredTitle = styled.h1`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
`;

class InstructorPeerReview extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      surveys: [],
    };
  }

  componentDidMount() {
    getRequest(
      `${process.env.REACT_APP_API_URL}v2/forms/surveys/`
    )
      .then(res => {
        const surveys = res.body.results;

        let endedSurveys = [];
        let openedSurveys = [];

        surveys.forEach(survey => {
          if (isSurveyFinished(survey)) {
            endedSurveys = [survey, ...endedSurveys];
          } else {
            openedSurveys = [...openedSurveys, survey];
          }
        });

        this.setState({
          loaded: true,
          surveys: [...openedSurveys, ...endedSurveys]
        });
      })
      .catch(err => { });
  }

  render() {
    const {
      loaded,
      surveys,
    } = this.state;

    return loaded ? (
      <Wrapper>
        {
          surveys.length > 0 && surveys.map(survey => (
            <PeerEvaluation
              key={survey.id}
              survey={survey}
              displayCheckMark={false}
              viewOnly={true}
            />
          ))
        }
        {
          (!surveys || surveys.length === 0) &&
          <CenteredTitle>No peer evaluations exist for this course yet.</CenteredTitle>
        }
      </Wrapper>
    ) : <Wrapper><Loader type="ball-scale-ripple" active /></Wrapper>;
  }
}

export default InstructorPeerReview;



// WEBPACK FOOTER //
// ./src/instructor/containers/peer-review.js